import React, { useState } from "react";
import Header from "./Header";
import dayjs from "dayjs";

export default function Contact({ event }) {
  const start_date = dayjs(event.start_date).format("DD-MMMM-YYYY");
  const end_date = dayjs(event.end_date).format("DD-MMMM-YYYY");

  const [contactData, setContactData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setContactData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage("");

    try {
      const response = await fetch(`/api/events/${event.event_slug}/contact/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(contactData),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message || "Your message has been succesfully sent");
        setContactData({
          name: "",
          email: "",
          message: "",
        });
        setTimeout(() => {
          window.location.href = `/events/${event.event_slug}/contact`;
        });
      } else {
        let errorMessage = "An error occurred. Please try again.";

        if (data.error) {
          errorMessage = data.error;
        } else if (typeof data === "object") {
          const firstKey = Object.keys(data)[0];
          const firstError = data[firstKey][0];
          errorMessage = firstError;
        }

        setMessage(errorMessage);
      }
    } catch (error) {
      setMessage("Network error: " + error.message);
    }

    setIsLoading(false);
  };

  return (
    <div>
      <Header />
      {/* CTA */}
      <section className="overflow-hidden bg-gradient-to-b from-[#cce0f0] to-white sm:grid sm:grid-cols-2 sm:items-center mb-5">
        <div className="p-8 md:p-12 lg:px-16 lg:py-24">
          <div className="mx-auto max-w-xl text-center ">
            <h2 className="text-xl font-bold text-gray-900">
              Venue
            </h2>
            <p className=" text-bold md:mt-4 md:block">
              📍 {event.venue} <br />
              Dates:{" "}
              <strong>
                {" "}
                {start_date} – {end_date}{" "}
              </strong>
            </p>
          </div>
        </div>
        <iframe
          src={event.google_venue}
          className="object-cover sm:h-[calc(100%-2rem)] sm:self-end sm:rounded-ss-[20px] md:h-[calc(100%-4rem)] md:rounded-ss-[60px] mb-3"
          style={{ border: 0 }}
          width="600"
          height="450"
          allowFullscreen={true}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Sarova Whitesands"
        ></iframe>
      </section>
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8 bg-gradient-to-b from-[#dceaf5] to-white">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
          <div className="md:py-4">
            <h2 className="text-2xl font-bold text-gray-900 sm:text-3xl">
              Get in touch
            </h2>

            <p className="mt-4 text-pretty text-gray-700">
              We value your feedback and inquiries. Whether you have questions
              about the conference, registration, sponsorship, speaking
              opportunities, or logistics, our team is here to assist you. Feel
              free to reach out using the contact details below or send us a
              message through the form.
            </p>
            {/* contact-info */}
            <dl className="mt-6 space-y-3">
              <div>
                <dt className="sr-only">Phone number</dt>

                <dd className="grid grid-cols-[24px_1fr] items-center gap-2 text-gray-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="size-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"
                    ></path>
                  </svg>

                  <span className="font-medium">+254 (20) 694 8000</span>
                </dd>
              </div>

              <div>
                <dt className="sr-only">Email</dt>

                <dd className="grid grid-cols-[24px_1fr] items-center gap-2 text-gray-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="size-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                    ></path>
                  </svg>

                  <span className="font-medium">info@kebs.org</span>
                </dd>
              </div>

              <div>
                <dt className="sr-only">Location</dt>

                <dd className="grid grid-cols-[24px_1fr] items-center gap-2 text-gray-700">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    className="size-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                    ></path>
                  </svg>

                  <span className="font-medium">
                    Kenya Bureau of Standards (KEBS) Popo Road, South C,
                    Nairobi, Kenya
                  </span>
                </dd>
              </div>
            </dl>
          </div>
          {/* feedback form */}
          <form
            onSubmit={handleSubmit}
            className="space-y-4 rounded-lg border border-gray-300 bg-[#0166b1] p-6 dark:border-gray-600"
          >
            <div>
              <label
                className="block font-medium text-gray-900 dark:text-white"
                for="name"
              >
                Name
              </label>

              <input
                className="mt-1 w-full p-2 border-gray-300 focus:border-indigo-500 focus:outline-none dark:border-gray-600"
                id="name"
                type="text"
                placeholder="Your name"
                value={contactData.name}
                onChange={handleChange}
              />
            </div>

            <div>
              <label
                className="block text-sm font-medium text-gray-900 dark:text-white"
                for="email"
              >
                Email
              </label>

              <input
                className="mt-1 w-full p-2 border-gray-300 focus:border-indigo-500 focus:outline-none dark:border-gray-600"
                id="email"
                type="email"
                placeholder="Your email"
                value={contactData.email}
                onChange={handleChange}
              />
            </div>

            <div>
              <label
                className="block text-sm font-medium text-gray-900 dark:text-white"
                for="message"
              >
                Message
              </label>

              <textarea
                className="mt-1 w-full resize-none p-2 border-gray-300 focus:border-indigo-500 focus:outline-none dark:border-gray-600"
                id="message"
                rows="4"
                placeholder="Your message"
                value={contactData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            <button
              className="block w-full rounded-lg border border-indigo-600 bg-gray-700 px-12 py-3 text-sm font-medium text-white transition-colors hover:bg-transparent hover:text-indigo-600 dark:hover:bg-black dark:hover:text-white"
              type="submit"
            >
              {isLoading ? "Submitting..." : "Send Message"}
            </button>
          </form>
          {message && (
            <div className="max-w-lg mx-auto p-4 mb-4 text-center text-white bg-indigo-600 rounded">
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
